module.exports = __webpack_public_path__ + "img/jn-bottom.6a134f8f.png";